import React, { useState } from 'react';
import { buildApiUrl } from '../utils/api';

const EmailVerification = ({ userId, onVerificationSuccess, onBackToLogin }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch(buildApiUrl('/api/verify-email'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, code }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(data.message);
        setTimeout(() => {
          onVerificationSuccess(data.token, data.user);
        }, 2000);
      } else {
        setError(data.message || 'Erro ao verificar código');
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setError('');
    setResendLoading(true);

    try {
      const response = await fetch(buildApiUrl('/api/resend-verification'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(data.message);
      } else {
        setError(data.message || 'Erro ao reenviar código');
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Verificar Email</h1>
        <p className="auth-subtitle">
          Digite o código de 6 dígitos enviado para seu email
        </p>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Código de Verificação</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              placeholder="Digite o código de 6 dígitos"
              maxLength="6"
              style={{ 
                textAlign: 'center', 
                fontSize: '24px', 
                letterSpacing: '8px',
                fontFamily: 'monospace'
              }}
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Verificando...' : 'Verificar Código'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button 
            onClick={handleResendCode}
            className="btn btn-secondary"
            disabled={resendLoading}
            style={{ marginBottom: '10px' }}
          >
            {resendLoading ? 'Enviando...' : 'Reenviar Código'}
          </button>
          
          <div style={{ marginTop: '10px' }}>
            <button 
              onClick={onBackToLogin}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: '#667eea', 
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              Voltar para o Login Microsoft
            </button>
          </div>
        </div>

        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          background: '#f8f9fa', 
          borderRadius: '8px',
          fontSize: '14px',
          color: '#666'
        }}>
          <strong>Dica:</strong> Verifique sua pasta de spam se não recebeu o email.
          O código expira em 10 minutos.
        </div>
      </div>
    </div>
  );
};

export default EmailVerification; 
